import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Rectangle,
  Cushion,
  MaxWidth,
  Typography,
  AbsoluteContainer,
  RelativeContainer,
} from '@pitchero/react-ui';
import Icon from '../../icon';
import { getShopBannerClosed } from '../../../store/shop/selectors';
import { toggleShopBannerClosed as toggleShopBannerClosedAction } from '../../../store/shop/actions';
import useAnimation from '../../use-animation';
import { Trans } from '../../../lib/i18n';

const animationSteps = [
  {
    maxHeight: '0px',
    opacity: '0.2',
  },
  {
    maxHeight: '350px',
    opacity: '1',
  },
];

const AssignmentsCompleteBanner = ({
  bannerClosed,
  toggleShopBannerClosed,
  canClose,
  enableAnimation,
}) => {
  // This is here because hooks relies on call order
  // Attempting to but this under the if statement causes react to throw errors
  const { maxHeight, opacity } = useAnimation(
    enableAnimation ? animationSteps : animationSteps.slice(1),
    enableAnimation,
  );

  if (bannerClosed && canClose) {
    return null;
  }

  return (
    <Rectangle
      fill="mercury"
      className="shop-assignment-list"
      style={{
        maxHeight,
        opacity,
        overflow: 'hidden',
        height: 'auto',
        willChange: 'max-height, opacity',
        transition: 'max-height 700ms, opacity 700ms',
      }}
    >
      <Cushion vertical={canClose ? '0' : 'small'} component="div">
        {canClose && (
          <MaxWidth component="div" maxWidth={1366} center>
            <RelativeContainer>
              <AbsoluteContainer right={24} top={24}>
                <Icon
                  name="cross"
                  onClick={() => toggleShopBannerClosed(true)}
                  color="dustygrey"
                  style={{ cursor: 'pointer' }}
                />
              </AbsoluteContainer>
            </RelativeContainer>
          </MaxWidth>
        )}
        <Cushion
          all="large"
          style={{ textAlign: 'center' }}
          component="div"
          responsive={[{ minWidth: 'tab', props: { all: 'xlarge' } }]}
        >
          <Rectangle
            fill="primary"
            radius="circle"
            component="div"
            style={{
              display: 'inline-block',
              height: '45px',
              width: '45px',
              zIndex: 999,
            }}
          >
            <Cushion all={12}>
              <Icon name="tick" color="white" size={22} />
            </Cushion>
          </Rectangle>
          <Cushion top="small" bottom="xsmall">
            <Typography preset="staticSubtitle--large" component="div">
              <Trans i18nKey="shop:assignments_completed_banner_header">
                You&apos;re all up-to-date with your payments
              </Trans>
            </Typography>
          </Cushion>
          <Typography preset="body--small" color="dustygrey">
            <Trans i18nKey="shop:assignments_completed_banner_body">
              Nice work, there aren’t any products you need to buy
            </Trans>
          </Typography>
        </Cushion>
      </Cushion>
    </Rectangle>
  );
};

AssignmentsCompleteBanner.propTypes = {
  enableAnimation: PropTypes.bool.isRequired,
  bannerClosed: PropTypes.bool.isRequired,
  toggleShopBannerClosed: PropTypes.func.isRequired,
  canClose: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  bannerClosed: getShopBannerClosed(state),
});

export default connect(mapStateToProps, { toggleShopBannerClosed: toggleShopBannerClosedAction })(
  AssignmentsCompleteBanner,
);
